export default __webpack_public_path__ + "static/media/guestbook_title.13eb024a.png";